module.exports = __webpack_public_path__ + "static/media/ic-field-rect.56d3cf90.svg";